module.exports = __webpack_public_path__ + "static/bg-purple-49ec100d873d00c1971d76be26d1f0b9.jpg";